export const MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const MONTH_ABBR = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

// Stored dob has no year (e.g. "16 Aug") since birthdays repeat yearly.
export const parseDob = (dobStr) => {
  if (!dobStr) return null;
  const parts = dobStr.trim().split(" ");
  if (parts.length !== 2) return null;
  const day = parseInt(parts[0], 10);
  const month = MONTH_ABBR.indexOf(parts[1]);
  if (Number.isNaN(day) || month === -1) return null;
  return { day, month };
};

export const getOrdinal = (n) => {
  const suffixes = ["th", "st", "nd", "rd"];
  const v = n % 100;
  return `${n}${suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]}`;
};

// Returns the 7 actual calendar dates (Monday..Sunday) of the present week,
// so a week spanning a month/year boundary is still matched correctly.
export const getCurrentWeekDates = () => {
  const now = new Date();
  const dow = now.getDay(); // 0 Sun .. 6 Sat
  const diffToMonday = dow === 0 ? -6 : 1 - dow;
  const monday = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate() + diffToMonday,
  );
  return Array.from({ length: 7 }, (_, i) => {
    const d = new Date(monday);
    d.setDate(monday.getDate() + i);
    return d;
  });
};

// e.g. "August 10-16th Celebrant"; if the week crosses a month boundary,
// e.g. "Jul 29 - Aug 4th Celebrant".
export const getWeekLabel = (weekDates) => {
  const monday = weekDates[0];
  const sunday = weekDates[6];
  const endLabel = getOrdinal(sunday.getDate());
  if (monday.getMonth() === sunday.getMonth()) {
    return `${MONTH_NAMES[monday.getMonth()]} ${monday.getDate()}-${endLabel} Celebrant`;
  }
  return `${MONTH_ABBR[monday.getMonth()]} ${monday.getDate()} - ${MONTH_ABBR[sunday.getMonth()]} ${endLabel} Celebrant`;
};
